import { useBootstrap } from "../api/queries/useBootstrap";

/**
 * `boot.tenant.environment`, rendered prominently whenever it is not `prod`; absent on prod.
 */
export function EnvironmentBadge({ className }: { className?: string }) {
  const { data } = useBootstrap();
  const environment = data?.tenant.environment;
  if (!environment || environment.toLowerCase() === "prod") return null;

  return (
    <span
      className={`type-caption inline-flex items-center rounded-sm bg-state-upload-invalid-bg px-xs py-[1px] font-semibold tracking-wide text-state-upload-invalid-fg uppercase ${className ?? ""}`}
      title={`Environment: ${environment}`}
    >
      {environment}
    </span>
  );
}
